import script from "./MemberDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./MemberDetailsModal.vue?vue&type=style&index=0&id=5e2af03d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e2af03d"]])

export default __exports__